import React from "react";
import { Typography, Button } from "antd";
import moment from "moment";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const { Title } = Typography;

const PeriodSelector = (props) => {
  const { currentDate, onNextDate, onPreviousDate } = props;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        width: "200px",
        paddingBottom: "5px",
      }}
    >
      <Button
        type="text"
        shape="circle"
        icon={<RightOutlined />}
        onClick={onPreviousDate}
      />
      <Title level={4} style={{ margin: "0px", lineHeight: 1.5 }}>
        {moment(currentDate).format("MMMM YYYY")}
      </Title>
      <Button
        type="text"
        shape="circle"
        icon={<LeftOutlined />}
        onClick={onNextDate}
      />
    </div>
  );
};

export default PeriodSelector;
